import { VDRFolderView } from '../../../slices/marketplace/data-room/models/vdr-folder-view.model';

export interface BreadcrumbItem {
    id: string;
    name: string;
}

export class VDRFolderNavigationHelper {
    private rootFolder: VDRFolderView | undefined;

    constructor(rootFolder: VDRFolderView | undefined) {
        this.rootFolder = rootFolder;
    }

    findFolderByPath(path: string, folder?: VDRFolderView): VDRFolderView | undefined {
        if (!folder) {
            folder = this.rootFolder;
        }
        if (!folder) {
            return undefined;
        }

        if (folder.fullPath === path) {
            return folder;
        }

        for (const subFolder of folder.subFolders) {
            const found = this.findFolderByPath(path, subFolder);
            if (found) {
                return found;
            }
        }

        return undefined;
    }

    buildBreadcrumbFromPath(path: string): BreadcrumbItem[] {
        if (!this.rootFolder) {
            return [];
        }

        const buildPath = (
            targetPath: string,
            currentFolder: VDRFolderView,
            pathSoFar: BreadcrumbItem[]
        ): BreadcrumbItem[] | null => {
            if (currentFolder.fullPath === targetPath) {
                return [...pathSoFar, {
                    id: currentFolder.fullPath,
                    name: currentFolder.name,
                }];
            }

            for (const subFolder of currentFolder.subFolders) {
                const result = buildPath(
                    targetPath,
                    subFolder,
                    [...pathSoFar, {
                        id: currentFolder.fullPath,
                        name: currentFolder.name,
                    }]
                );
                if (result) {
                    return result;
                }
            }

            return null;
        };

        const result = buildPath(path, this.rootFolder, []);
        return result || [{
            id: this.rootFolder.fullPath,
            name: this.rootFolder.name,
        }];
    }
}

